"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onEnter = void 0;
var voyageSystems_rack_sidecar_1 = require("@voyage/systems/voyageSystems_rack-sidecar");
function onEnter(obj) {
    voyageSystems_rack_sidecar_1.voyageSystems_rack.swapItemHere(obj, true);
}
exports.onEnter = onEnter;
